import { FormattedMessage } from 'components/shared/Intl';
import type { ISalesCounterpart } from 'models/ISalesCounterpart';
import { FC } from 'react';

import type { SearchResultProps } from '../SelectSearch/SelectSearch';
import { SalesCounterPartSearchResultItem } from './SalesCounterPartResultItem';

export interface SalesCounterPartResultOwnProps {
  maxHeight?: string;
  isClientLabelWrapped?: boolean;
  showHeader?: boolean;
}

export type SalesCounterPartResultProps = SalesCounterPartResultOwnProps & SearchResultProps<ISalesCounterpart>;

export const SalesCounterPartResult: FC<SalesCounterPartResultProps> = ({
  data,
  onSelected,
  currentIndex,
  searchedText,
  getError,
  maxHeight = '16rem',
  isClientLabelWrapped = false,
  showHeader = true,
}) => {
  if (data.length === 0) {
    return null;
  }

  return (
    <div style={{ maxHeight }} className="overflow-y-auto border-top mt-2">
      <table className="table table-hover table-sm" data-e2e="client-search-items">
        {showHeader && (
          <thead>
            <tr>
              <th>
                <FormattedMessage id="client.name" />
              </th>
              <th>
                <FormattedMessage id="client.country" />
              </th>
              <th className="w-25">
                <FormattedMessage id="client.bdrId" />
              </th>
              <th>
                <FormattedMessage id="client.eliotCode" />
              </th>
            </tr>
          </thead>
        )}
        <tbody>
          {data.map((item, idx) => {
            return (
              <SalesCounterPartSearchResultItem
                key={item.id}
                item={item}
                onSelected={onSelected}
                isSelected={idx === currentIndex}
                searchedText={searchedText}
                getError={getError}
                isClientLabelWrapped={isClientLabelWrapped}
              />
            );
          })}
        </tbody>
      </table>
    </div>
  );
};
SalesCounterPartResult.displayName = 'SalesCounterPartResult';
